import React, { useEffect } from "react";
import { Typography, Stack, Box } from "@mui/material";
import { Container, IconContainer, CustomButton } from "./style";
import ErrorImage from "../../assets/Images/error.png";

const Error404 = () => {
  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("roleType");
  }, []);
  return (
    <Container>
      <Box className="leftContent">
        <Typography variant="h3" component="h1" gutterBottom>
          Something's wrong here...
        </Typography>
        <Typography variant="body1" gutterBottom>
          We can't find the page you're looking for.
          <br /> Check out our Help Center or head back to home.
        </Typography>
        <Stack direction="row" spacing={2} mt={2}>
          <CustomButton
            variant="contained"
            size="large"
            color="primary"
            href="/"
          >
            Login
          </CustomButton>
        </Stack>
      </Box>
      <IconContainer>
        <img src={ErrorImage} width={"250px"} />
      </IconContainer>
    </Container>
  );
};

export default Error404;
